import { Operation } from 'shell/view-models/operation';
import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersFormTerritory } from './types';

export const transformDataset = (values: FiltersFormTerritory): string => {
  const { orders, page, rowsPerPage, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codice: {
      value: otherValues.code,
      operation: Operation.LIKE,
    },
    codiceStato: {
      value: otherValues.state,
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    codice: ordersToTransform.code,
    codiceStato: ordersToTransform.state,
    esonimo: ordersToTransform.exonym,
    endonimo: ordersToTransform.endonym,
  };

  return `?${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};
